import { render, staticRenderFns } from "./WalletInterest.vue?vue&type=template&id=4e9a0006&scoped=true"
import script from "./WalletInterest.vue?vue&type=script&lang=js"
export * from "./WalletInterest.vue?vue&type=script&lang=js"
import style0 from "./WalletInterest.vue?vue&type=style&index=0&id=4e9a0006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9a0006",
  null
  
)

export default component.exports